// extracted by mini-css-extract-plugin
export default {"errorContainer":"styles_errorContainer__o5gyM","heading":"styles_heading__Tp+mR","subtitle":"styles_subtitle__Y+UrS","button":"styles_button__InGN5","image":"styles_image__Zh5tB"};